import {Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
// import AOS from 'aos';
@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class LittleFarmHomePageComponent implements OnInit {
  categories = [
    {
      image: 'assets/little-farm/files/images/3/content-images/Beef.jpg',
      subheading: 'Pastured',
      heading: 'BEEF',
      link: ''
    },
    {
      image: 'assets/little-farm/files/images/3/content-images/Chicken.jpg',
      subheading: 'Small Batch',
      heading: 'POULTRY',
      link: ''
    },
    {
      image: 'assets/little-farm/files/images/3/content-images/bacon.jpg',
      subheading: 'Heritage',
      heading: 'PORK',
      link: ''
    },
    {
      image: 'assets/little-farm/files/images/3/content-images/Dairy.jpg',
      subheading: 'Ethically Raised',
      heading: 'CHEESE & DAIRY',
      link: ''
    },
    {
      image: 'assets/little-farm/files/images/3/content-images/GardenProcuce.JPG',
      subheading: 'Farm Fresh',
      heading: 'GARDEN PRODUCE',
      link: ''
    },
    {
      image: 'assets/little-farm/files/images/3/content-images/BakedGoods.jpg',
      subheading: 'Freshly Made',
      heading: 'Baked Goods',
      link: ''
    }
  ];
  constructor() {
   }

  ngOnInit(): void {
  }
}
